(function () {
  'use strict';

  // Schutz-Flag: verhindert, dass der alte Fallback aus layout/theme.liquid diese Version ueberschreibt.
  window.__TIB_FRAME_CUSTOMIZER_V2__ = true;

  // ======================================================
  // KONFIGURATION (einfach anpassbar)
  // ======================================================
  // Key = gewaehlte "Verfuegbare Produkte" Input-ID (z. B. 344993 = Poster, 345245 = Leinwand)
  // Value = Name-zu-Bild-URL Mapping fuer die Rahmenfarben
  const FRAME_IMAGE_MAP_BY_PRODUCT = {
    '344993': {
      'Kein Rahmen': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Poster_ohne_Rahmen_5c4c7e72-741a-4b7e-a8f4-d55aae75d828.png?v=1786353142',
      'Schwarz': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Posterrahmen_schwarz.png?v=1786288064',
      'Weiss': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Posterrahmen_weiss.png?v=1786288064',
      'Oak': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Posterrahmen_oak.png?v=1786288064',
      'Walnuss': 'https://cdn.artvera.cloud/generated/picture-frames/product/1/1000_1000/rog-50022-h-dz_walnuss-natur.webp'
    },
    '345245': {
      'Kein Rahmen': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Leinwand_ohne_Rahmen_04a949f6-b1f4-4f40-8272-fe1dc55a30a6.png?v=1786353142',
      'Schwarz': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Leinwand_Rahmen_schwarz.png?v=1786288046',
      'Weiss': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Leinwand_Rahmen_weiss.png?v=1786288048',
      'Oak': 'https://cdn.shopify.com/s/files/1/0379/6418/5733/files/Leinwand_Rahmen_Oak.png?v=1786288047',
      'Walnuss': 'https://cdn.artvera.cloud/generated/picture-frames/product/1/1000_1000/rog-50022-h-dz_walnuss-natur.webp'
    }
  };

  // Optionaler Beschreibungstext unterhalb der Rahmenzeile pro Produkt-ID.
  const FRAME_DESCRIPTION_BY_PRODUCT = {
    '344993': 'Veredele dein Poster mit einem Echtholz-Rahmen mit Glasfront für einen stimmigen, hochwertigen und schönen Look.',
    '345245': 'Ein Schattenfugenrahmen aus Echtholz gibt deiner Leinwand einen klaren, ästhetischen Galerie-Look.'
  };

  var lastSyncedPriceSignature = '';

  var lastFrameConsoleLogSignature = '';

  function getTitleTextLower(block) {
    if (!block) return '';
    var titleEl = block.querySelector('.tee-option__title');
    return titleEl && titleEl.textContent ? titleEl.textContent.toLowerCase() : '';
  }

  function getQueryParam(name) {
    try {
      if (typeof URLSearchParams !== 'undefined') {
        return new URLSearchParams(window.location.search).get(name) || '';
      }
    } catch (e) {
      // Fallback below
    }

    var search = (window.location.search || '').replace(/^\?/, '');
    if (!search) return '';
    var pairs = search.split('&');
    for (var i = 0; i < pairs.length; i += 1) {
      var parts = pairs[i].split('=');
      if (decodeURIComponent(parts[0] || '') === name) {
        return decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
      }
    }
    return '';
  }

  function elementMatches(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    var fn = el.matches || el.msMatchesSelector || el.webkitMatchesSelector;
    return !!(fn && fn.call(el, selector));
  }

  function closestBySelector(el, selector) {
    var current = el;
    while (current && current.nodeType === 1) {
      if (elementMatches(current, selector)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function removeElement(el) {
    if (!el || !el.parentNode) return;
    el.parentNode.removeChild(el);
  }

  // Schreibt nur, wenn sich der Wert wirklich aendert. Jeder blinde
  // style.setProperty()-Aufruf erzeugt sonst einen MutationRecord und
  // haelt damit die Observer-Schleife am Leben.
  function setStyle(el, prop, value) {
    if (!el || !el.style) return;
    if (el.style.getPropertyValue(prop) === value && el.style.getPropertyPriority(prop) === 'important') return;
    el.style.setProperty(prop, value, 'important');
  }

  function normalizeFrameKey(rawName) {
    const name = (rawName || '').toLowerCase().trim();

    if (!name) return '';
    if (name.includes('ohne')) return 'Kein Rahmen';
    if (name.includes('kein')) return 'Kein Rahmen';
    if (name.includes('schwarz')) return 'Schwarz';
    if (name.includes('weiss') || name.includes('wei') || name.includes('white')) return 'Weiss';
    if (name.includes('oak')) return 'Oak';
    if (name.includes('walnuss') || name.includes('walnut')) return 'Walnuss';

    return '';
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function findAvailableProductsSelectionId() {
    const availableBlock = normalizeAvailableProductsSelection();
    if (availableBlock) {
      const selectedInput = availableBlock.querySelector('.tee-radio.active input[type="radio"]')
        || availableBlock.querySelector('.tee-radio[aria-checked="true"] input[type="radio"]')
        || availableBlock.querySelector('input[type="radio"]:checked');

      if (selectedInput) {
        const value = (selectedInput.value || '').trim();
        if (FRAME_IMAGE_MAP_BY_PRODUCT[value]) {
          return value;
        }
      }

      const radios = availableBlock.querySelectorAll('input[type="radio"]');
      for (let r = 0; r < radios.length; r += 1) {
        const value = (radios[r].value || '').trim();
        if (FRAME_IMAGE_MAP_BY_PRODUCT[value]) {
          return value;
        }
      }
    }

    const optionBlocks = document.querySelectorAll('.tee-option');

    for (let i = 0; i < optionBlocks.length; i += 1) {
      const block = optionBlocks[i];
      const title = getTitleTextLower(block).trim();
      if (!title.includes('verf')) continue;

      // 1) Klassischer Fall: echter checked-Radio
      let selectedInput = block.querySelector('input[type="radio"]:checked');

      // 2) TeeInBlue-Fall: Auswahl nur ueber .active am Wrapper
      if (!selectedInput) {
        selectedInput = block.querySelector('.tee-radio.active input[type="radio"]');
      }

      // 3) TeeInBlue-Fall: Auswahl ueber ARIA-Status am Wrapper
      if (!selectedInput) {
        selectedInput = block.querySelector('.tee-radio[aria-checked="true"] input[type="radio"]');
      }

      if (selectedInput) {
        const value = (selectedInput.value || '').trim();
        if (FRAME_IMAGE_MAP_BY_PRODUCT[value]) {
          return value;
        }
      }

      // 4) Letzter Fallback: erster Radio-Wert, der im Mapping existiert
      const radios = block.querySelectorAll('input[type="radio"]');
      for (let r = 0; r < radios.length; r += 1) {
        const value = (radios[r].value || '').trim();
        if (FRAME_IMAGE_MAP_BY_PRODUCT[value]) {
          return value;
        }
      }
    }

    return '';
  }

  function normalizeAvailableProductsSelection() {
    const optionBlocks = document.querySelectorAll('.tee-option');
    let block = null;

    for (let i = 0; i < optionBlocks.length; i += 1) {
      const current = optionBlocks[i];
      const title = getTitleTextLower(current).trim();
      if (title.includes('verf')) {
        block = current;
        break;
      }
    }

    if (!block) return null;

    const wrappers = Array.from(block.querySelectorAll('.tee-radio'));
    if (!wrappers.length) return block;

    let selectedWrapper = wrappers.find(function (w) { return w.classList.contains('active'); });
    if (!selectedWrapper) {
      selectedWrapper = wrappers.find(function (w) { return w.getAttribute('aria-checked') === 'true'; });
    }
    if (!selectedWrapper) {
      selectedWrapper = wrappers.find(function (w) {
        const input = w.querySelector('input[type="radio"]');
        return !!(input && input.checked);
      });
    }
    if (!selectedWrapper) {
      selectedWrapper = wrappers[0];
    }

    wrappers.forEach(function (wrapper) {
      const input = wrapper.querySelector('input[type="radio"]');
      const isSelected = wrapper === selectedWrapper;
      const ariaValue = isSelected ? 'true' : 'false';

      // Nur bei tatsaechlicher Aenderung schreiben - sonst erzeugt jeder
      // Durchlauf Mutationen, auf die die Observer wieder reagieren.
      if (wrapper.classList.contains('active') !== isSelected) {
        wrapper.classList.toggle('active', isSelected);
      }
      if (wrapper.getAttribute('aria-checked') !== ariaValue) {
        wrapper.setAttribute('aria-checked', ariaValue);
      }

      if (input && input.checked !== isSelected) {
        input.checked = isSelected;
      }
    });

    return block;
  }

  function moveFrameBlockToLastPosition(frameBlock) {
    if (frameBlock.getAttribute('data-frame-position-locked') === '1') {
      return;
    }

    let moved = false;
    const parent = frameBlock.parentElement;
    if (parent) {
      const siblingOptions = Array.from(parent.children).filter(function (el) {
        return el.classList && el.classList.contains('tee-option');
      });

      const lastOption = siblingOptions[siblingOptions.length - 1];
      if (lastOption && lastOption !== frameBlock) {
        parent.appendChild(frameBlock);
        moved = true;
      }
    }

    const teeFormActions = document.getElementById('teeFormActions');
    const teeFormInputs = document.getElementById('teeFormInputs');

    if (teeFormActions && teeFormActions.parentNode) {
      if (teeFormActions.previousElementSibling !== frameBlock) {
        teeFormActions.parentNode.insertBefore(frameBlock, teeFormActions);
        moved = true;
      }
      if (moved || teeFormActions.previousElementSibling === frameBlock) {
        frameBlock.setAttribute('data-frame-position-locked', '1');
      }
      return;
    }

    if (teeFormInputs && teeFormInputs.parentNode) {
      if (teeFormInputs.parentNode.lastElementChild !== frameBlock) {
        teeFormInputs.parentNode.appendChild(frameBlock);
        moved = true;
      }
      if (moved || teeFormInputs.parentNode.lastElementChild === frameBlock) {
        frameBlock.setAttribute('data-frame-position-locked', '1');
      }
    }
  }

  function buildFrameMarkupWithDiff(imageUrl, safeTitle, diffText, titleHtml) {
    var diffHtml = diffText ? '<span class="custom-frame-diff">' + escapeHtml(diffText) + '</span>' : '';
    return '' +
      '<div class="custom-frame-item">' +
        '<div class="custom-frame-card">' +
          '<img src="' + imageUrl + '" alt="' + safeTitle + '" loading="lazy">' +
          '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" class="tee-clipart-checkmark" viewBox="0 0 52 52">' +
            '<path fill="none" d="m14.1 27.2 7.1 7.2 16.7-16.8" class="tee-clipart-checkmark__check"></path>' +
          '</svg>' +
        '</div>' +
        '<span class="custom-frame-title">' + (titleHtml || safeTitle) + '</span>' +
        diffHtml +
      '</div>';
  }

  function parseMoneyToCents(text) {
    var raw = (text || '').toString().trim();
    if (!raw) return null;

    var normalized = raw
      .replace(/\s/g, '')
      .replace(/€/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    var num = Number(normalized);
    if (!isFinite(num)) return null;
    return Math.round(num * 100);
  }

  function formatCentsToEuro(cents) {
    var abs = Math.abs(cents);
    var intPart = Math.floor(abs / 100);
    var decPart = String(abs % 100).padStart(2, '0');
    return intPart + ',' + decPart + ' €';
  }

  function normalizeVariantPart(text) {
    return (text || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function parseVariantOption(optionEl) {
    if (!optionEl) return null;
    var parts = (optionEl.textContent || '').split('/').map(function (part) {
      return part.trim();
    });
    if (parts.length < 3) return null;

    return {
      productPart: normalizeVariantPart(parts[0]),
      sizePart: normalizeVariantPart(parts[1]),
      frameKey: normalizeFrameKey(parts.slice(2).join(' / ')),
      priceCents: parseMoneyToCents(optionEl.getAttribute('data-price') || ''),
      value: optionEl.value || ''
    };
  }

  // TeeInBlue setzt select[name="id"] zwischendurch auf IDs, die im Select gar
  // nicht vorkommen. Dann liefert selectedOptions nichts und ohne Rueckfall
  // waeren schlagartig bei allen Kacheln die Aufpreise weg.
  var lastGoodVariantSelection = null;

  function readCheckedFrameKeyFromForm() {
    var inputs = document.querySelectorAll('.custom-frame-wrapper input[type="radio"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (!inputs[i].checked) continue;
      var wrapper = closestBySelector(inputs[i], '.custom-frame-wrapper');
      if (wrapper && wrapper.offsetParent === null) continue;
      var key = normalizeFrameKey(inputs[i].value);
      if (key) return key;
    }
    return '';
  }

  function findVariantOptionParsed(options, productPart, sizePart, frameKey) {
    for (var i = 0; i < options.length; i += 1) {
      var parsed = parseVariantOption(options[i]);
      if (!parsed || parsed.priceCents === null) continue;
      if (parsed.productPart !== productPart) continue;
      if (parsed.sizePart !== sizePart) continue;
      if (parsed.frameKey !== frameKey) continue;
      return parsed;
    }
    return null;
  }

  function resolveSelectedVariantOption(selectEl, options) {
    var candidates = [];
    if (selectEl.selectedOptions && selectEl.selectedOptions.length) candidates.push(selectEl.selectedOptions[0]);
    if (selectEl.selectedIndex >= 0) candidates.push(options[selectEl.selectedIndex]);
    for (var i = 0; i < options.length; i += 1) {
      if (options[i].value === selectEl.value) candidates.push(options[i]);
    }

    for (var c = 0; c < candidates.length; c += 1) {
      var parsed = parseVariantOption(candidates[c]);
      if (parsed && parsed.priceCents !== null) return parsed;
    }
    return null;
  }

  function buildFrameDiffMapForCurrentSelection() {
    var selectEl = document.querySelector('select[name="id"]');
    if (!selectEl) {
      return {
        map: {},
        selectedFrameKey: ''
      };
    }

    var options = Array.from(selectEl.options);
    var selectedParsed = resolveSelectedVariantOption(selectEl, options);

    if (selectedParsed) {
      lastGoodVariantSelection = selectedParsed;
    } else if (lastGoodVariantSelection) {
      // Produkt und Groesse aus dem letzten gueltigen Stand, den Rahmen aber
      // aus den Radios - so bleibt der Bezugspreis auch dann korrekt, wenn nur
      // der Select gerade unbrauchbar ist.
      var fallbackFrameKey = readCheckedFrameKeyFromForm() || lastGoodVariantSelection.frameKey;
      selectedParsed = findVariantOptionParsed(
        options,
        lastGoodVariantSelection.productPart,
        lastGoodVariantSelection.sizePart,
        fallbackFrameKey
      ) || lastGoodVariantSelection;
    }

    if (!selectedParsed) {
      return {
        map: {},
        selectedFrameKey: ''
      };
    }

    var map = {};

    options.forEach(function (opt) {
      var parsed = parseVariantOption(opt);
      if (!parsed) return;
      if (!parsed.frameKey) return;
      if (parsed.priceCents === null) return;

      if (parsed.productPart !== selectedParsed.productPart) return;
      if (parsed.sizePart !== selectedParsed.sizePart) return;

      map[parsed.frameKey] = parsed.priceCents - selectedParsed.priceCents;
    });

    return {
      map: map,
      selectedFrameKey: selectedParsed.frameKey || ''
    };
  }

  function formatFrameDiffText(diffCents, frameKey, selectedFrameKey) {
    if (typeof diffCents !== 'number' || !isFinite(diffCents)) return '';
    // Die aktuelle Auswahl ist die Bezugsgroesse und bekommt keine Differenz.
    if (frameKey && frameKey === selectedFrameKey) return '';
    return (diffCents < 0 ? '- ' : '+ ') + formatCentsToEuro(Math.abs(diffCents));
  }

  function detectFrameBlockProductId(frameBlock) {
    if (!frameBlock) return '';

    var knownProductIds = Object.keys(FRAME_IMAGE_MAP_BY_PRODUCT);
    var radios = frameBlock.querySelectorAll('input[type="radio"]');

    for (var i = 0; i < radios.length; i += 1) {
      var input = radios[i];
      var probe = [input.id || '', input.name || '', input.value || '', input.getAttribute('data-id') || ''].join(' ');

      for (var p = 0; p < knownProductIds.length; p += 1) {
        var pid = knownProductIds[p];
        if (probe.indexOf('-' + pid + '-') !== -1 || probe.indexOf('_' + pid + '_') !== -1 || probe.indexOf(pid) !== -1) {
          return pid;
        }
      }
    }

    return '';
  }

  function getCurrentVariantIdFromUrl() {
    return getQueryParam('variant');
  }

  function syncVariantAndPriceFromUrl() {
    var variantId = getCurrentVariantIdFromUrl();
    // Nur Ziffern: ein beliebiger Parameterwert landet sonst ungeprueft im Attributselektor.
    if (!variantId || !/^\d+$/.test(variantId)) return;

    var masterSelect = document.querySelector('select[name="id"], input[name="id"]');
    if (!masterSelect) return;

    var optionEl = null;
    if (masterSelect.tagName === 'SELECT') {
      optionEl = masterSelect.querySelector('option[value="' + variantId + '"]');
      // Ohne passende Option setzt die Zuweisung unten den Select auf "" - danach
      // fehlt der Aufpreis-Berechnung die Bezugsvariante und alle Preise verschwinden.
      if (!optionEl) return;
    }

    if (masterSelect.value !== variantId) {
      masterSelect.value = variantId;
      masterSelect.dispatchEvent(new Event('input', { bubbles: true }));
      masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var priceText = optionEl ? (optionEl.getAttribute('data-price') || '').trim() : '';
    var compareText = optionEl ? (optionEl.getAttribute('data-compare') || optionEl.getAttribute('data-compare-at-price') || '').trim() : '';
    if (!priceText) return;

    var signature = [variantId, priceText, compareText].join('|');
    if (signature === lastSyncedPriceSignature) return;
    lastSyncedPriceSignature = signature;

    // Hauptpreis-Box im Produktbereich
    document.querySelectorAll('.ext-p-price').forEach(function (box) {
      var priceEl = box.querySelector('.price-item');
      if (priceEl && priceEl.textContent !== priceText) {
        priceEl.textContent = priceText;
      }

      var compareEl = box.querySelector('.ext-p-compare');
      if (compareEl) {
        if (compareText) {
          compareEl.textContent = compareText;
          compareEl.style.removeProperty('display');
        } else {
          compareEl.style.setProperty('display', 'none', 'important');
        }
      }

      var saleBadge = box.querySelector('.ext-p-badge');
      if (saleBadge) {
        if (compareText) {
          saleBadge.style.removeProperty('display');
        } else {
          saleBadge.style.setProperty('display', 'none', 'important');
        }
      }
    });

    // TeeInBlue Preisanzeige ebenfalls synchron halten
    document.querySelectorAll('.tee-price--current').forEach(function (el) {
      if (el.textContent !== priceText) {
        el.textContent = priceText;
      }
    });

    document.querySelectorAll('.tee-price--compare').forEach(function (el) {
      if (compareText) {
        el.textContent = compareText;
        el.style.removeProperty('display');
      } else {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function getVisibleFrameNames() {
    const frameBlocks = Array.from(document.querySelectorAll('.tee-option')).filter(function (block) {
      const titleEl = block.querySelector('.tee-option__title');
      return titleEl && (titleEl.textContent || '').toLowerCase().includes('passenden rahmen');
    });

    const visibleBlock = frameBlocks.find(function (block) {
      return window.getComputedStyle(block).display !== 'none';
    });

    if (!visibleBlock) return [];

    const wrappers = Array.from(visibleBlock.querySelectorAll('.tee-radio'));
    return wrappers.map(function (wrapper) {
      const input = wrapper.querySelector('input[type="radio"]');
      if (!input) return '';
      const label = wrapper.querySelector('.tee-radio-label');
      const title = (label && label.getAttribute('title')) || '';
      return (input.value || title || '').trim();
    }).filter(Boolean);
  }

  function logSelectedVariantAndVisibleFrames(selectedProductId) {
    const variantId = getCurrentVariantIdFromUrl();
    const visibleFrameNames = getVisibleFrameNames();
    const signature = [variantId, selectedProductId || '', visibleFrameNames.join('|')].join('::');

    if (signature === lastFrameConsoleLogSignature) return;
    lastFrameConsoleLogSignature = signature;

    console.log('[TIB] Auswahl-Status', {
      variantId: variantId,
      productId: selectedProductId || '',
      visibleFrames: visibleFrameNames
    });
  }

  function hideFrameBlock(frameBlock) {
    setStyle(frameBlock, 'display', 'none');
    if (frameBlock.getAttribute('aria-hidden') !== 'true') {
      frameBlock.setAttribute('aria-hidden', 'true');
    }

    var desc = frameBlock.querySelector('.custom-frame-description');
    if (desc) removeElement(desc);
  }

  function showFrameBlock(frameBlock) {
    if (frameBlock.style.getPropertyValue('display')) {
      frameBlock.style.removeProperty('display');
    }
    if (frameBlock.hasAttribute('aria-hidden')) {
      frameBlock.removeAttribute('aria-hidden');
    }
  }

  function cleanupHiddenDuplicateFrameBlocks(frameBlocks, selectedProductId) {
    var keptOtherProduct = false;

    // Rueckwaerts laufen, damit der neueste Block je Produkt-ID erhalten bleibt.
    for (var i = frameBlocks.length - 1; i >= 0; i -= 1) {
      var block = frameBlocks[i];
      var display = window.getComputedStyle(block).display;
      if (display !== 'none') continue;

      var pid = detectFrameBlockProductId(block);

      // Hidden-Block der aktiven Produkt-ID nie behalten (es gibt ja einen sichtbaren aktiven Block).
      if (!pid || pid === selectedProductId) {
        removeElement(block);
        continue;
      }

      // Fuer die inaktive Produkt-ID maximal einen Hidden-Block als Fallback behalten.
      if (!keptOtherProduct) {
        keptOtherProduct = true;
        continue;
      }

      removeElement(block);
    }
  }

  function readFrameName(item) {
    var input = item.querySelector('input[type="radio"]');
    var label = item.querySelector('.tee-radio-label');
    if (!input || !label) return '';
    return (input.value || (label.getAttribute('title') || '').trim() || label.textContent || '').trim();
  }

  function customizeFrameBlock(frameBlock, imageMap) {
    if (!frameBlock.classList.contains('custom-frame-wrapper')) {
      frameBlock.classList.add('custom-frame-wrapper');
    }

    const optionInner = frameBlock.querySelector('.tee-option-inner');
    if (!optionInner) return;

    const isMobileLayout = window.matchMedia('(max-width: 767px)').matches;
    setStyle(optionInner, 'display', 'flex');
    setStyle(optionInner, 'flex-wrap', 'wrap');
    setStyle(optionInner, 'justify-content', 'flex-start');
    setStyle(optionInner, 'column-gap', isMobileLayout ? '10px' : '16px');
    setStyle(optionInner, 'row-gap', isMobileLayout ? '12px' : '16px');
    setStyle(optionInner, 'padding-top', '12px');
    setStyle(optionInner, 'padding-bottom', isMobileLayout ? '10px' : '16px');

    const radioItems = frameBlock.querySelectorAll('.tee-radio');
    const items = Array.prototype.slice.call(radioItems);
    var frameDiffContext = buildFrameDiffMapForCurrentSelection();
    var frameDiffMap = frameDiffContext.map || {};
    var frameSelectedKey = frameDiffContext.selectedFrameKey || '';

    // Nur wenn wirklich jeder Name aus zwei Woertern besteht, wird nach dem
    // ersten umgebrochen - sonst stehen ein- und zweizeilige Titel gemischt da.
    var frameNames = items.map(readFrameName).filter(Boolean);
    var useTwoLineTitles = frameNames.length === items.length && frameNames.every(function (name) {
      return name.split(/\s+/).length === 2;
    });

    items.forEach(function (item) {
      const input = item.querySelector('input[type="radio"]');
      const label = item.querySelector('.tee-radio-label');
      if (!input || !label) return;

      // TeeInBlue laesst "aria-checked" auf der zuvor gewaehlten Kachel
      // stehen - ohne diesen Abgleich meldet der Screenreader zwei
      // ausgewaehlte Rahmen. Nur bei echter Aenderung schreiben, sonst
      // reagieren die Observer auf jede eigene Mutation.
      const ariaValue = (item.classList.contains('active') || input.checked) ? 'true' : 'false';
      if (item.getAttribute('aria-checked') !== ariaValue) {
        item.setAttribute('aria-checked', ariaValue);
      }

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const tileSize = isMobile ? 74 : 100;

      if (item.classList.contains('tee-swatch--circle')) {
        item.classList.remove('tee-swatch--circle');
      }
      setStyle(item, 'width', isMobile ? 'calc((100% - 30px) / 4)' : '100px');
      setStyle(item, 'min-height', (tileSize + 28) + 'px');
      setStyle(item, 'height', 'auto');
      setStyle(item, 'min-width', '0');
      setStyle(item, 'border', 'none');
      setStyle(item, 'border-radius', '0');
      setStyle(item, 'box-shadow', 'none');
      setStyle(item, 'background', 'transparent');
      setStyle(item, 'outline', 'none');

      setStyle(label, 'width', tileSize + 'px');
      setStyle(label, 'height', 'auto');
      setStyle(label, 'overflow', 'visible');
      setStyle(label, 'border', 'none');
      setStyle(label, 'border-radius', '0');
      setStyle(label, 'box-shadow', 'none');
      setStyle(label, 'background', 'transparent');
      setStyle(label, 'outline', 'none');

      const fallbackTitle = (label.getAttribute('title') || '').trim();
      const frameName = (input.value || fallbackTitle || label.textContent || '').trim();
      const normalizedKey = normalizeFrameKey(frameName);
      const imageUrl = imageMap[normalizedKey] || '';

      if (!imageUrl) return;

      const safeTitle = escapeHtml(frameName);
      const titleHtml = useTwoLineTitles
        ? frameName.split(/\s+/).map(escapeHtml).join('<br>')
        : safeTitle;
      const diffText = formatFrameDiffText(frameDiffMap[normalizedKey], normalizedKey, frameSelectedKey);
      const renderKey = [normalizedKey, imageUrl, frameName, diffText, useTwoLineTitles ? '2z' : '1z'].join('|');
      // Der Schluessel haengt am Item, der Inhalt im Label: rendert TeeInBlue das
      // Label neu, bliebe die Kachel sonst dauerhaft im fremden Zustand stehen.
      if (item.getAttribute('data-frame-render-key') === renderKey && label.querySelector('.custom-frame-item')) {
        return;
      }

      label.innerHTML = buildFrameMarkupWithDiff(imageUrl, safeTitle, diffText, titleHtml);
      item.setAttribute('data-frame-render-key', renderKey);
    });

    moveFrameBlockToLastPosition(frameBlock);
  }

  function upsertFrameDescription(frameBlock, text) {
    var existing = frameBlock.querySelector('.custom-frame-description');
    var optionInner = frameBlock.querySelector('.tee-option-inner');

    if (!text) {
      if (existing) removeElement(existing);
      return;
    }

    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'custom-frame-description';
      frameBlock.appendChild(existing);
    }

    if (optionInner) {
      var innerStyles = window.getComputedStyle(optionInner);
      setStyle(existing, 'margin-left', innerStyles.marginLeft || '0px');
      setStyle(existing, 'margin-right', innerStyles.marginRight || '0px');
    }

    if (existing.textContent !== text) {
      existing.textContent = text;
    }
  }

  function applyFrameCustomization() {
    normalizeAvailableProductsSelection();
    syncVariantAndPriceFromUrl();

    const selectedProductId = findAvailableProductsSelectionId();
    const imageMap = FRAME_IMAGE_MAP_BY_PRODUCT[selectedProductId] || null;
    const frameDescription = FRAME_DESCRIPTION_BY_PRODUCT[selectedProductId] || '';
    const optionBlocks = document.querySelectorAll('.tee-option');
    const frameBlocks = Array.prototype.filter.call(optionBlocks, function (block) {
      const titleEl = block.querySelector('.tee-option__title');
      if (!titleEl) return false;
      return (titleEl.textContent || '').toLowerCase().includes('passenden rahmen');
    });

    if (!frameBlocks.length) return;

    if (!imageMap) {
      frameBlocks.forEach(function (block) { hideFrameBlock(block); });
      return;
    }

    var visibleBlock = null;

    frameBlocks.forEach(function (block) {
      var blockProductId = detectFrameBlockProductId(block);
      var matchesSelected = blockProductId === selectedProductId;

      // Fallback: wenn keine Produkt-ID erkennbar ist, darf genau ein Block sichtbar bleiben.
      if (!blockProductId && !visibleBlock) {
        matchesSelected = true;
      }

      if (matchesSelected && !visibleBlock) {
        visibleBlock = block;
        showFrameBlock(block);
        customizeFrameBlock(block, imageMap);
        upsertFrameDescription(block, frameDescription);
      } else {
        hideFrameBlock(block);
      }
    });

    // Sicherheitsnetz: Falls nichts matcht, lieber ALLE Rahmen verbergen statt falsche anzuzeigen.
    if (!visibleBlock) {
      frameBlocks.forEach(function (block) { hideFrameBlock(block); });
    }

    cleanupHiddenDuplicateFrameBlocks(frameBlocks, selectedProductId);
    syncVariantAndPriceFromUrl();
    logSelectedVariantAndVisibleFrames(selectedProductId);
  }

  var FRAME_SCROLL_KEY = 'tib_frame_scroll_lock_v1';
  var frameTopJumpProtection = null;
  var lastUserScrollIntentTs = 0;

  function markUserScrollIntent() {
    lastUserScrollIntentTs = Date.now();
    if (frameTopJumpProtection) {
      frameTopJumpProtection.cancelledByUser = true;
    }
  }

  function clearFrameTopJumpProtection() {
    if (frameTopJumpProtection && frameTopJumpProtection.cleanupTimer) {
      clearTimeout(frameTopJumpProtection.cleanupTimer);
    }
    frameTopJumpProtection = null;
  }

  function maybePreventFrameTopJump() {
    if (!frameTopJumpProtection) return;

    if (Date.now() > frameTopJumpProtection.until || frameTopJumpProtection.cancelledByUser) {
      clearFrameTopJumpProtection();
      return;
    }

    // Wenn der Nutzer gerade bewusst gescrollt hat, niemals zurueckziehen.
    if (Date.now() - lastUserScrollIntentTs < 180) {
      clearFrameTopJumpProtection();
      return;
    }

    var jumpedToTop = window.scrollY <= 8 && frameTopJumpProtection.y > 80;
    if (jumpedToTop) {
      // Bewusst nur EIN einziges Mal pro Aktivierung korrigieren.
      // Vorher konnte diese Funktion innerhalb des 1,2s-Fensters bei
      // JEDEM scroll-Event erneut zuruecksetzen. Auf iOS meldet Safari
      // beim Momentum-/Rubberband-Scrollen kurzzeitig scrollY == 0 -
      // dadurch wurde der Nutzer beim Scrollen immer wieder nach oben
      // gerissen ("Seite springt hoch").
      window.scrollTo(0, frameTopJumpProtection.y);
      clearFrameTopJumpProtection();
    }
  }

  function armFrameTopJumpProtection(y) {
    clearFrameTopJumpProtection();

    // Ohne sinnvolle Ausgangsposition gar nicht erst scharfschalten.
    if (typeof y !== 'number' || y <= 80) return;

    frameTopJumpProtection = {
      y: y,
      // Fenster von 1200ms auf 500ms verkuerzt: der Sprung passiert -
      // wenn ueberhaupt - unmittelbar nach dem Klick. Alles danach ist
      // mit hoher Wahrscheinlichkeit echtes Nutzer-Scrollen.
      until: Date.now() + 500,
      cancelledByUser: false,
      cleanupTimer: null
    };

    requestAnimationFrame(maybePreventFrameTopJump);
    setTimeout(maybePreventFrameTopJump, 80);
    setTimeout(maybePreventFrameTopJump, 220);
    frameTopJumpProtection.cleanupTimer = setTimeout(clearFrameTopJumpProtection, 600);
  }

  function saveFrameScrollLock() {
    try {
      sessionStorage.setItem(FRAME_SCROLL_KEY, JSON.stringify({
        y: window.scrollY,
        ts: Date.now()
      }));
    } catch (e) {
      // Ignore storage errors (private mode / quota)
    }
  }

  function restoreFrameScrollLock() {
    try {
      var raw = sessionStorage.getItem(FRAME_SCROLL_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.y !== 'number' || typeof parsed.ts !== 'number') return;

      // Nur unmittelbar nach der Interaktion wiederherstellen. Frueher
      // waren das 3000ms - lange genug, dass ein normaler Seitenwechsel
      // dazwischenpasst und die neu geladene Seite ungefragt gescrollt
      // wurde.
      if (Date.now() - parsed.ts > 1200) {
        sessionStorage.removeItem(FRAME_SCROLL_KEY);
        return;
      }

      var y = parsed.y;
      if (window.scrollY <= 8 && y > 80) {
        armFrameTopJumpProtection(y);
        window.scrollTo(0, y);
      }

      sessionStorage.removeItem(FRAME_SCROLL_KEY);
    } catch (e) {
      // Ignore parse/storage errors
    }
  }

  function init() {
    let tries = 0;
    const maxTries = 40;

    try {
      applyFrameCustomization();
    } catch (e) {
      console.error('[TIB] initial applyFrameCustomization failed', e);
    }

    const timer = setInterval(function () {
      tries += 1;
      applyNow('interval');
      rescopeObserver();
      if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 300);

    let restoreScrollY = null;
    let observer = null;
    let isApplying = false;
    let scheduleHandle = null;
    let runsInWindow = 0;
    let windowStart = 0;
    let circuitOpen = false;

    // applyFrameCustomization() schreibt selbst ins DOM (Klassen,
    // Inline-Styles, innerHTML, Umsortieren des Rahmen-Blocks). Weil der
    // MutationObserver weiter unten genau darauf hoert, hat sich das
    // frueher selbst getriggert: Mutation -> rAF -> apply -> Mutation ...
    // 60x pro Sekunde, dauerhaft. Genau dieses Aufschaukeln ist die
    // Ursache fuer "Container waechst / Seite ruckelt".
    //
    // Zwei Sperren dagegen:
    //  1. isApplying   -> kein Re-Entry waehrend wir selbst schreiben
    //  2. takeRecords()-> die von UNS erzeugten Records verwerfen
    function applyNow(reason) {
      if (isApplying) return;
      isApplying = true;
      try {
        safeApplyFrameCustomization(reason);
      } finally {
        if (observer) observer.takeRecords();
        isApplying = false;
      }
    }

    const scheduleApply = function (opts) {
      const keepScroll = !!(opts && opts.keepScroll);
      if (keepScroll && restoreScrollY === null) {
        restoreScrollY = window.scrollY;
      }

      if (circuitOpen || scheduleHandle !== null) return;
      // Trailing-Throttle (max. ~6 Laeufe/Sekunde) statt einmal pro
      // Frame - reicht optisch voellig aus und kann nicht mehr mit dem
      // Rendering der App um die Wette laufen.
      scheduleHandle = setTimeout(function () {
        scheduleHandle = null;

        const now = Date.now();
        if (now - windowStart > 1000) {
          windowStart = now;
          runsInWindow = 0;
        }
        runsInWindow += 1;
        if (runsInWindow > 12) {
          circuitOpen = true;
          if (observer) observer.disconnect();
          if (window.console && console.warn) {
            console.warn('[TIB] Layout-Schleife erkannt - Rahmen-Anpassung wurde gestoppt.');
          }
          return;
        }

        applyNow('scheduleApply');

        if (restoreScrollY !== null) {
          armFrameTopJumpProtection(restoreScrollY);
          restoreScrollY = null;
        }
      }, 160);
    };

    observer = new MutationObserver(function () {
      if (isApplying) return;
      scheduleApply();
    });

    function safeApplyFrameCustomization(reason) {
      try {
        applyFrameCustomization();
      } catch (e) {
        console.error('[TIB] applyFrameCustomization failed', reason, e);
      }
    }

    function resolveFrameRadioInputFromTarget(target) {
      if (!target) return null;

      var label = closestBySelector(target, '.tee-radio-label');
      if (!label) return null;

      var option = closestBySelector(label, '.tee-option');
      if (!option) return null;

      var optionTitle = (option.querySelector('.tee-option__title') ? option.querySelector('.tee-option__title').textContent : '').toLowerCase();
      var isFrameOption = option.classList.contains('custom-frame-wrapper') || optionTitle.includes('passenden rahmen');
      if (!isFrameOption) return null;

      var input = null;
      var forId = label.getAttribute('for');
      if (forId) {
        input = document.getElementById(forId);
      }

      if (!input) {
        var parent = label.parentElement;
        input = parent ? parent.querySelector('input[type="radio"]') : null;
      }

      if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return null;

      return {
        input: input,
        option: option
      };
    }

    // Beobachtungsbereich so eng wie moeglich halten: nur das
    // TeeInBlue-Formular, nicht das komplette <body>. Vorher hat JEDE
    // Aenderung irgendwo auf der Seite (Header, Sticky-Klassen, andere
    // Apps, unser eigenes zweites Custom-Liquid-Skript) diesen Observer
    // ausgeloest - und dessen Schreibvorgaenge wiederum die anderen
    // Observer. Genau dieses Ping-Pong hat die Seite endlos wachsen
    // lassen.
    //
    // Solange die App noch nicht gerendert hat, muessen wir notgedrungen
    // <body> beobachten - sobald das Formular existiert, engen wir
    // sofort ein (siehe rescopeObserver(), aufgerufen aus dem Intervall).
    let observedRoot = null;

    function rescopeObserver() {
      if (circuitOpen || !observer) return;
      const root = document.getElementById('teeinblue-form')
        || document.querySelector('.tee-customization-wrapper')
        || document.body;
      if (root === observedRoot) return;
      observedRoot = root;
      observer.disconnect();
      observer.observe(root, { childList: true, subtree: true });
    }

    rescopeObserver();

    window.addEventListener('scroll', function () {
      maybePreventFrameTopJump();
    }, { passive: true, capture: true });

    window.addEventListener('wheel', markUserScrollIntent, { passive: true, capture: true });
    window.addEventListener('touchstart', markUserScrollIntent, { passive: true, capture: true });
    window.addEventListener('touchmove', markUserScrollIntent, { passive: true, capture: true });
    window.addEventListener('keydown', function (event) {
      var key = event && event.key;
      if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'PageDown' || key === 'PageUp' || key === 'Home' || key === 'End' || key === ' ' || key === 'Spacebar') {
        markUserScrollIntent();
      }
    }, true);

    document.body.addEventListener('pointerdown', function (event) {
      var resolved = resolveFrameRadioInputFromTarget(event.target);
      if (!resolved) return;

      // Verhindert den nativen Label-Default, der den versteckten Input fokussiert
      // und dadurch auf manchen Geraeten nach oben scrollt.
      event.preventDefault();
      event.__tibFrameHandled = true;
      armFrameTopJumpProtection(window.scrollY);
      saveFrameScrollLock();
    }, true);

    document.body.addEventListener('click', function (event) {
      var resolved = resolveFrameRadioInputFromTarget(event.target);
      if (!resolved) return;

      event.preventDefault();
      event.__tibFrameHandled = true;

      var input = resolved.input;
      var wasChecked = !!input.checked;

      armFrameTopJumpProtection(window.scrollY);
      saveFrameScrollLock();

      if (!wasChecked) {
        input.checked = true;
      }

      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      scheduleApply({ keepScroll: true });
    }, true);

    document.body.addEventListener('click', function (event) {
      if (event.__tibFrameHandled) return;
      var target = event.target;
      if (!target) return;

      var option = closestBySelector(target, '.tee-option');
      if (!option) return;

      var optionTitle = (option.querySelector('.tee-option__title') ? option.querySelector('.tee-option__title').textContent : '').toLowerCase();
      var isFrameOption = option.classList.contains('custom-frame-wrapper') || optionTitle.includes('passenden rahmen');
      if (!isFrameOption) return;

      armFrameTopJumpProtection(window.scrollY);
      saveFrameScrollLock();
    }, true);

    document.body.addEventListener('change', function (event) {
      const target = event.target;

      // Der Variantenselect bestimmt die Preise und damit die Aufpreise.
      if (target && target.tagName === 'SELECT' && target.name === 'id') {
        scheduleApply();
        return;
      }

      if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return;

      const option = closestBySelector(target, '.tee-option');
      const optionTitle = (option && option.querySelector('.tee-option__title') ? option.querySelector('.tee-option__title').textContent : '').toLowerCase();
      const isFrameOption = option && (option.classList.contains('custom-frame-wrapper') || optionTitle.includes('passenden rahmen'));

      if (isFrameOption) {
        armFrameTopJumpProtection(window.scrollY);
        saveFrameScrollLock();
      }

      scheduleApply({ keepScroll: !!isFrameOption });

      if (isFrameOption) {
        // Some variant scripts scroll after our RAF; re-apply lock shortly after.
        setTimeout(restoreFrameScrollLock, 0);
      }
    }, true);

    // TeeInBlue stellt nach einem Reload die gespeicherte Konfiguration erst
    // verzoegert wieder her und setzt den Variantenselect dabei per Skript.
    // Das loest weder ein change-Event noch eine DOM-Mutation aus - ohne
    // diese Kontrolle blieben die Aufpreise auf dem Stand des ersten Rendern.
    var lastVariantValue = null;
    setInterval(function () {
      var variantSelect = document.querySelector('select[name="id"]');
      if (!variantSelect) return;
      if (lastVariantValue === variantSelect.value) return;
      lastVariantValue = variantSelect.value;
      applyNow('variant-watch');
    }, 500);

    // Kachelgroesse, Spaltenbreite und Abstaende haengen am Breakpoint und
    // werden als Inline-Styles gesetzt - nach Resize oder Geraetedrehung
    // muessen sie neu berechnet werden. Reine Hoehenaenderungen (mobile
    // Adressleiste) bleiben aussen vor.
    var lastLayoutWidth = window.innerWidth;
    var layoutResizeHandle = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastLayoutWidth) return;
      lastLayoutWidth = window.innerWidth;
      if (layoutResizeHandle) clearTimeout(layoutResizeHandle);
      layoutResizeHandle = setTimeout(function () {
        layoutResizeHandle = null;
        applyNow('resize');
      }, 120);
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        safeApplyFrameCustomization('pageshow');
      }
      restoreFrameScrollLock();
    });

    // Restore pending lock after a full reload caused by variant update.
    restoreFrameScrollLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
